import React, { useContext, useMemo, type JSX } from 'react';
import useHandledQuery from '../QueryComponents/HandledQuery/HandledQueryHook';
import query from './BakgrundsjobbQuery.gql';
import {
  BakgrundsjobbQuery as IData,
  BakgrundsjobbQueryVariables as IVariables,
} from './_QueryTypes/BakgrundsjobbQuery';
import { ActiveDatabaseContext } from '../ActiveDatabaseContext/ActiveDatabaseContext';
import mergeSort from '../../Utils/mergeSort';
import {
  TEDSYSJobbSTATUSEnum,
  TEDSelectionConditionType,
  TEDSelectionOperator,
} from '../../globalQueryTypes';
import moment from 'moment';

interface IProps {
  children: (jobb: ISysJobb[]) => JSX.Element;
  pollInterval?: number;
}

export interface ISysJobb {
  title: string;
  status: TEDSYSJobbSTATUSEnum;
  start: Date;
  minutesLeft: number | null;
  end: Date;
  user: string;
  progress: number;
}

const BakgrundsjobbQuery: React.FC<IProps> = props => {
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const startDateFilter = useMemo(
    () =>
      moment(new Date().toLocaleString('sv-SE'))
        .subtract(3, 'days')
        .locale('sv-SE')
        .format('YYYY-MM-DD HH:mm:ss'),
    []
  );

  const queryResult = useHandledQuery<IData, IVariables>(query, {
    variables: {
      db: activeDatabaseContext.activeDatabase || '',
      selection: [
        [
          {
            namn: 'START_TID',
            typ: TEDSelectionConditionType.Value,
            valueCondition: {
              op: TEDSelectionOperator.greater,
              value: [{ value: startDateFilter }],
            },
          },
        ],
      ],
    },
    pollInterval: props.pollInterval,
  });
  if (
    queryResult.data &&
    queryResult.data.db &&
    queryResult.data.db.SYSJobb_All
  ) {
    const jobb = mergeSort(
      queryResult.data.db.SYSJobb_All.map(j => {
        const start = new Date(j.START_TID);
        const end = moment(start)
          .add(j.MinuterKvar ? Math.floor(j.MinuterKvar) : 0, 'm')
          .toDate();
        return {
          title: j.RUBRIK || '',
          status: j.STATUS || TEDSYSJobbSTATUSEnum.VILANDE,
          start: new Date(j.START_TID),
          minutesLeft: j.MinuterKvar ? Math.floor(j.MinuterKvar) : null,
          end: end,
          user:
            j._Associations &&
            j._Associations.Anvandare &&
            j._Associations.Anvandare.Name
              ? j._Associations.Anvandare.Name
              : '',
          progress: j.PROGRESS || 0,
        };
      }),
      (a, b) => a.start.getTime() - b.start.getTime()
    );
    return props.children(jobb);
  } else {
    return queryResult.renderComponent;
  }
};

export default BakgrundsjobbQuery;
